import { render, staticRenderFns } from "./helpcenter-overview.vue?vue&type=template&id=87112e2e&"
import script from "./helpcenter-overview.vue?vue&type=script&lang=js&"
export * from "./helpcenter-overview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports